import { Col, FormInstance, Row, Typography } from "antd";
import { CustomForm } from "../../Form/index.styled";
import { CheckableTagForm } from "./Form/CheckableTag";
import { RadioGroupForm } from "./Form/RadioGroup";

interface UserInfoServiceTireFormProps {
  form: FormInstance<any>;
  readonly?: boolean;
}

/**
 * 타이어 교체
 * @param param0
 * @returns
 */
export const UserInfoServiceTireForm: React.FC<
  UserInfoServiceTireFormProps
> = ({ form, readonly = false }) => {
  return (
    <>
      <CustomForm.Item>
        <RadioGroupForm
          name={[
            "repairShopOption",
            "options",
            "services",
            "tire",
            "isActivated",
          ]}
          rules={[
            {
              required: true,
            },
          ]}
          readonly={readonly}
        />
      </CustomForm.Item>
      <CustomForm.Item noStyle shouldUpdate>
        {({ getFieldValue }) =>
          getFieldValue([
            "repairShopOption",
            "options",
            "services",
            "tire",
            "isActivated",
          ]) && (
            <CustomForm.Item
              name={["repairShopOption", "options", "services", "tire"]}
              rules={[
                {
                  validator: (rule, value) => {
                    if (value && value?.isActivated === true) {
                      const checked = Object.entries(value).filter(
                        ([key, val]) =>
                          ![
                            "isActivated",
                            "maxAspectRatio",
                            "minAspectRatio",
                            "maxInch",
                            "maxInch",
                          ].includes(key) && val === true
                      );

                      if (checked.length > 0) {
                        return Promise.resolve();
                      }
                    }
                    return Promise.reject(new Error("하나 이상 선택하세요."));
                  },
                },
              ]}
            >
              <Row gutter={readonly ? [4, 8] : [0, 8]}>
                <CustomForm.Item
                  noStyle
                  hidden
                  name={[
                    "repairShopOption",
                    "options",
                    "services",
                    "tire",
                    "maxAspectRatio",
                  ]}
                />
                <CustomForm.Item
                  noStyle
                  hidden
                  name={[
                    "repairShopOption",
                    "options",
                    "services",
                    "tire",
                    "minAspectRatio",
                  ]}
                />
                <Col span={24}>
                  <Typography.Title level={5} style={{ marginTop: 24 }}>
                    차종 및 특수타이어
                  </Typography.Title>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "domesticVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "domesticVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      국산차(내연)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "incomeVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "incomeVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      수입차(내연)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "domesticElectricVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "domesticElectricVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      국산차(전기)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "incomeElectricVehicleHandleable",
                    ]}
                    valuePropName="checked"
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "incomeElectricVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      수입차(전기)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "rFTHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "rFTHandleable",
                      ])}
                      readonly={readonly}
                    >
                      런플랫
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                {/* <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "nineteenInchTireHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "nineteenInchTireHandleable",
                      ])}
                      readonly={readonly}
                    >
                      19인치 이하
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "twentyInchTireHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "twentyInchTireHandleable",
                      ])}
                      readonly={readonly}
                    >
                      20인치
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "twentyOneInchTireHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "twentyOneInchTireHandleable",
                      ])}
                      readonly={readonly}
                    >
                      21인치
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "tire",
                      "twentyTwoInchTireHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "tire",
                        "twentyTwoInchTireHandleable",
                      ])}
                      readonly={readonly}
                    >
                      22인치 이상
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col> */}
              </Row>
            </CustomForm.Item>
          )
        }
      </CustomForm.Item>
    </>
  );
};
